import { useState } from 'react';
import { useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import AdsLancamento from './pages/ads/AdsLancamento';
import AdsDashboard from './pages/ads/AdsDashboard';
import AdsConfiguracoes from './pages/ads/AdsConfiguracoes';
import AdsCliente from './pages/ads/AdsCliente';
import SocialChecklist from './pages/social/SocialChecklist';
import SocialCliente from './pages/social/SocialCliente';
import SocialCalendario from './pages/social/SocialCalendario';
import Admin from './pages/Admin';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Financeiro from './pages/Financeiro';
import Despesas from './pages/Despesas';
import Login from './pages/Login';
import Clientes from './pages/Clientes';
import DespesasFixas from './pages/DespesasFixas';
import FluxoCaixa from './pages/FluxoCaixa';
import CRM from './pages/CRM';

function App() {
  const { sessao, carregando } = useAuth();
  const [paginaAtiva, setPaginaAtiva] = useState('home');
  const [clienteAdsAtivo, setClienteAdsAtivo] = useState(null);
  const [clienteSocialAtivo, setClienteSocialAtivo] = useState(null);

  if (carregando) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <p className="text-gray-400">Carregando...</p>
      </div>
    );
  }

  if (!sessao) {
    return <Login onLogin={() => {}} />;
  }

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#0d0d0d' }}>
      <Sidebar paginaAtiva={paginaAtiva} setPaginaAtiva={setPaginaAtiva} />
      <div className="flex-1 p-8 overflow-auto" style={{ backgroundColor: '#0d0d0d' }}>
        {paginaAtiva === 'home' && <Home setPaginaAtiva={setPaginaAtiva} />}
        {paginaAtiva === 'dashboard'     && <Dashboard />}
        {paginaAtiva === 'financeiro'    && <Financeiro />}
        {paginaAtiva === 'despesas'      && <Despesas />}
        {paginaAtiva === 'clientes'      && <Clientes />}
        {paginaAtiva === 'despesasfixas' && <DespesasFixas />}
        {paginaAtiva === 'fluxo'         && <FluxoCaixa />}
        {paginaAtiva === 'crm'           && <CRM />}
        {paginaAtiva === 'ads'           && <AdsDashboard setPaginaAtiva={setPaginaAtiva} setClienteAdsAtivo={setClienteAdsAtivo} />}
        {paginaAtiva === 'social' && <SocialChecklist setPaginaAtiva={setPaginaAtiva} setClienteSocialAtivo={setClienteSocialAtivo} />}
        {paginaAtiva === 'ads_config' && <AdsConfiguracoes setPaginaAtiva={setPaginaAtiva} />}
        {paginaAtiva === 'social_calendario' && <SocialCalendario cliente={clienteSocialAtivo} setPaginaAtiva={setPaginaAtiva} />}
        {paginaAtiva === 'ads_lancamento'&& <AdsLancamento cliente={clienteAdsAtivo} setPaginaAtiva={setPaginaAtiva} />}
        {paginaAtiva === 'social_cliente' && <SocialCliente cliente={clienteSocialAtivo} setPaginaAtiva={setPaginaAtiva} setClienteSocialAtivo={setClienteSocialAtivo} />}
        {paginaAtiva === 'admin' && <Admin />}
        {paginaAtiva === 'ads_cliente' && <AdsCliente cliente={clienteAdsAtivo} setPaginaAtiva={setPaginaAtiva} setClienteAdsAtivo={setClienteAdsAtivo} />}
      </div>
    </div>
  );
}

export default App;